//@ts-nocheck
import { GetScriptsOutput } from '../../types'

export type ScriptContainer = {
  fileContent: string
  slug: string
}

export function getScripts(
  scripts: Record<string, Record<string, ScriptContainer>>,
  provider: 'ndr' | 'rga',
  payer: boolean,
  userRole: 'screener' | '*',
  lang: 'en' | 'es' = 'en',
): GetScriptsOutput {
  const key = `${lang}_${userRole === '*' ? '' : `${userRole.toLowerCase()}_`}${payer ? 'payer' : 'nonpayer'}_${provider}`
  return scripts[key] || {}
}
